import React from 'react';
import { Box, CircularProgress, Button } from '@mui/material';
import useUploadContext from '../../../hooks/useUploadContext/useUploadContext';
import { uploadProgressStyles } from './style';
import { useTranslation } from 'react-i18next';

interface UploadProgressProps {
  size?: number;
  buttonClassName?: string;
}

const UploadProgress: React.FC<UploadProgressProps> = ({ size = 70, buttonClassName = '' }) => {
  const { t } = useTranslation();
  const { uploadProgressContent } = uploadProgressStyles;
  const { progress, setProgress, setIsLoading, setUploadedFileName, uploadRequest, setFileInput } = useUploadContext();
  const handleCancelUpload = () => {
    if (uploadRequest.current) {
      uploadRequest.current.abort();
      setProgress(0);
      setIsLoading(false);
      setFileInput([]);
      setUploadedFileName('');
    }
  };

  return (
    <Box sx={uploadProgressContent}>
      <CircularProgress className="spinner" variant="determinate" size={size} value={progress} />
      <Button className={`cancel-upload-btn ${buttonClassName}`} onClick={handleCancelUpload}>
        {t('stop-upload')}
      </Button>
    </Box>
  );
};

export default UploadProgress;
